export const GeneralSettingsVI = {
    "applicationConfig": {
        "title": "Cài đặt chung",
        "button":{
            "setting":"Cài đặt"
        }
    },
    "applicationLeaveConfig": {
        "pageHeader": {
            "leave": "ĐƠN XIN NGHỈ",
            "sub": "Cho phép người dùng tạo đơn xin nghỉ"
        },
        "input": {
            "hour": "Sử dụng đơn xin nghỉ theo giờ",
            "maxDay": "Số ngày tối đa có thể làm đơn sau thời điểm xin nghỉ",
            "minDay": "Số ngày tối thiểu có thể làm đơn trước thời điểm xin nghỉ",
            "description": "Mô tả đơn xin nghỉ khi tạo đơn",
            "config": "Lý do xin nghỉ"
        },
        "label": {
            "accept": "Cho phép người dùng tạo đơn xin nghỉ",
            "acceptDetail": "Hãy tắt nó nếu công ty bạn không sử dụng đơn này",
            "hour": "Sử dụng đơn xin nghỉ theo giờ",
            "hourDetail": "Khi bật cài đặt này, hệ thống sẽ cho phép người dùng tạo đơn xin nghỉ theo giờ thay vì chọn nửa ca đầu, nửa ca sau",
            "maxDay": "Số ngày tối đa có thể làm đơn sau thời điểm xin nghỉ",
            "maxDayDetail": "VD: Nếu bạn cài đặt số ngày là 2, nhân sự muốn xin nghỉ từ ngày 04/07/2020 thì nhân sự đó chỉ có thể tạo đơn muộn nhất là ngày 06/07/2020",
            "minDay": "Số ngày tối thiểu có thể làm đơn trước thời điểm xin nghỉ",
            "minDayDetail": "VD: Nếu bạn cài đặt số ngày là 2, nhân sự muốn xin nghỉ từ ngày 04/07/2020 thì nhân sự đó phải tạo đơn trước 2 ngày là ngày 02/07/2020",
            "description": "Mô tả đơn xin nghỉ khi tạo đơn",
            "descriptionDetail": "Khi bật cài đặt này, nhân sự tạo đơn cần phải nhập nội dung mô tả thì hệ thống mới ghi nhận tạo mới thành công",
            "config": "Lý do xin nghỉ"
        }
    },
    "applicationAbsenceConfig": {
        "pageHeader": {
            "absence": "ĐƠN VẮNG MẶT",
            "sub": "Cho phép người dùng tạo đơn vắng mặt"
        },
        "input": {
            "hour": "Sử dụng đơn vắng mặt theo giờ",
            "maxDay": "Số ngày tối đa có thể làm đơn sau thời điểm vắng mặt",
            "minDay": "Số ngày tối thiểu có thể làm đơn trước thời điểm vắng mặt",
            "description": "Mô tả đơn vắng mặt khi tạo đơn",
            "config": "Lý do vắng mặt"
        },
        "label": {
            "accept": "Cho phép người dùng tạo đơn vắng mặt",
            "acceptDetail": "Hãy tắt nó nếu công ty bạn không sử dụng đơn này",
            "hour": "Sử dụng đơn vắng mặt theo giờ",
            "hourDetail": "Khi bật cài đặt này, hệ thống sẽ cho phép người dùng tạo đơn vắng mặt theo giờ thay vì chọn nửa ca đầu, nửa ca sau",
            "maxDay": "Số ngày tối đa có thể làm đơn sau thời điểm vắng mặt",
            "maxDayDetail": "VD: Nếu bạn cài đặt số ngày là 2, nhân sự muốn vắng mặt từ ngày 04/07/2020 thì nhân sự đó chỉ có thể tạo đơn muộn nhất là ngày 06/07/2020",
            "minDay": "Số ngày tối thiểu có thể làm đơn trước thời điểm vắng mặt",
            "minDayDetail": "VD: Nếu bạn cài đặt số ngày là 2, nhân sự muốn vắng mặt từ ngày 04/07/2020 thì nhân sự đó phải tạo đơn trước 2 ngày là ngày 02/07/2020",
            "description": "Mô tả đơn vắng mặt khi tạo đơn",
            "descriptionDetail": "Khi bật cài đặt này, nhân sự tạo đơn cần phải nhập nội dung mô tả thì hệ thống mới ghi nhận tạo mới thành công",
            "config": "Lý do vắng mặt"
        }
    },
    "applicationShiftMoreConfig": {
        "pageHeader": {
            "shiftMore": "ĐƠN TĂNG CA",
            "sub": "Cho phép người dùng tạo đơn tăng ca"
        },
        "input": {
            "hour": "Sử dụng đơn tăng ca theo giờ",
            "maxDay": "Số ngày tối đa có thể làm đơn sau thời điểm tăng ca",
            "minDay": "Số ngày tối thiểu có thể làm đơn trước thời điểm tăng ca",
            "description": "Mô tả đơn tăng ca khi tạo đơn",
            "config": "Lý do tăng ca"
        },
        "label": {
            "accept": "Cho phép người dùng tạo đơn tăng ca",
            "acceptDetail": "Hãy tắt nó nếu công ty bạn không sử dụng đơn này",
            "hour": "Sử dụng đơn tăng ca theo giờ",
            "hourDetail": "Khi bật cài đặt này, hệ thống sẽ cho phép người dùng tạo đơn tăng ca theo giờ thay vì chọn nửa ca đầu, nửa ca sau",
            "maxDay": "Số ngày tối đa có thể làm đơn sau thời điểm tăng ca",
            "maxDayDetail": "VD: Nếu bạn cài đặt số ngày là 2, nhân sự muốn tăng ca từ ngày 04/07/2020 thì nhân sự đó chỉ có thể tạo đơn muộn nhất là ngày 06/07/2020",
            "minDay": "Số ngày tối thiểu có thể làm đơn trước thời điểm tăng ca",
            "minDayDetail": "VD: Nếu bạn cài đặt số ngày là 2, nhân sự muốn tăng ca từ ngày 04/07/2020 thì nhân sự đó phải tạo đơn trước 2 ngày là ngày 02/07/2020",
            "description": "Mô tả đơn tăng ca khi tạo đơn",
            "descriptionDetail": "Khi bật cài đặt này, nhân sự tạo đơn cần phải nhập nội dung mô tả thì hệ thống mới ghi nhận tạo mới thành công",
            "config": "Lý do tăng ca"
        }
    },
    "applicationInoutConfig": {
        "pageHeader": {
            "inout": "ĐƠN CHECK IN/CHECK OUT",
            "sub": "Cho phép người dùng tạo đơn check in/check out"
        },
        "input": {
            "hour": "Sử dụng đơn check in/check out theo giờ",
            "day": "Số ngày tối đa có thể làm đơn sau thời điểm check in/check out",
            "minDay": "Số ngày tối thiểu có thể làm đơn trước thời điểm check in/check out",
            "description": "Mô tả đơn check in/check out khi tạo đơn",
            "config": "Lý do check in/check out"
        },
        "label": {
            "accept": "Cho phép người dùng tạo đơn check in/check out",
            "acceptDetail": "Hãy tắt nó nếu công ty bạn không sử dụng đơn này",
            "hour": "Sử dụng đơn check in/check out theo giờ",
            "hourDetail": "Khi bật cài đặt này, hệ thống sẽ cho phép người dùng tạo đơn check in/check out theo giờ thay vì chọn nửa ca đầu, nửa ca sau",
            "day": "Số ngày cho phép tạo đơn sau thời điểm quên checkin/out",
            "dayDetail": "VD: Nếu cài đặt số ngày là 3, nhân sự muốn tạo đơn checkin/out vào ngày 01/07/2020 thì nhân sự đó phải tạo đơn trước ngày 04/07/2020",
            "minDay": "Số ngày tối thiểu có thể làm đơn trước thời điểm check in/check out",
            "minDayDetail": "VD: Nếu bạn cài đặt số ngày là 2, nhân sự muốn check in/check out từ ngày 04/07/2020 thì nhân sự đó phải tạo đơn trước 2 ngày là ngày 02/07/2020",
            "description": "Mô tả đơn check in/check out khi tạo đơn",
            "descriptionDetail": "Khi bật cài đặt này, nhân sự tạo đơn cần phải nhập nội dung mô tả thì hệ thống mới ghi nhận tạo mới thành công",
            "config": "Lý do check in/check out"
        }
    },
    "applicationShiftChangeConfig": {
        "pageHeader": {
            "shiftChange": "ĐƠN ĐỔI CA",
            "sub": "Cho phép người dùng tạo đơn đổi ca"
        },
        "input": {
            "hour": "Sử dụng đơn đổi ca theo giờ",
            "maxDay": "Số ngày tối đa có thể làm đơn sau thời điểm đổi ca",
            "minDay": "Số ngày tối thiểu có thể làm đơn trước thời điểm đổi ca",
            "description": "Mô tả đơn đổi ca khi tạo đơn",
            "config": "Lý do đổi ca"
        },
        "label": {
            "accept": "Cho phép người dùng tạo đơn đổi ca",
            "acceptDetail": "Hãy tắt nó nếu công ty bạn không sử dụng đơn này",
            "hour": "Sử dụng đơn đổi ca theo giờ",
            "hourDetail": "Khi bật cài đặt này, hệ thống sẽ cho phép người dùng tạo đơn đổi ca theo giờ thay vì chọn nửa ca đầu, nửa ca sau",
            "maxDay": "Số ngày tối đa có thể làm đơn sau thời điểm đổi ca",
            "maxDayDetail": "VD: Nếu bạn cài đặt số ngày là 2, nhân sự muốn đổi ca từ ngày 04/07/2020 thì nhân sự đó chỉ có thể tạo đơn muộn nhất là ngày 06/07/2020",
            "minDay": "Số ngày tối thiểu có thể làm đơn trước thời điểm đổi ca",
            "minDayDetail": "VD: Nếu bạn cài đặt số ngày là 2, nhân sự muốn đổi ca từ ngày 04/07/2020 thì nhân sự đó phải tạo đơn trước 2 ngày là ngày 02/07/2020",
            "description": "Mô tả đơn đổi ca khi tạo đơn",
            "descriptionDetail": "Khi bật cài đặt này, nhân sự tạo đơn cần phải nhập nội dung mô tả thì hệ thống mới ghi nhận tạo mới thành công",
            "config": "Lý do đổi ca"
        }
    },
    "applicationShiftRegisterConfig": {
        "pageHeader": {
            "shiftRegister": "ĐƠN ĐĂNG KÝ CA",
            "sub": "Cho phép người dùng tạo đơn đăng ký ca"
        },
        "input": {
            "hour": "Sử dụng đơn đăng ký ca theo giờ",
            "maxDay": "Số ngày tối đa có thể làm đơn sau thời điểm đăng ký ca",
            "minDay": "Số ngày tối thiểu có thể làm đơn trước thời điểm đăng ký ca",
            "description": "Mô tả đơn đăng ký ca khi tạo đơn",
            "config": "Lý do đăng ký ca"
        },
        "label": {
            "accept": "Cho phép người dùng tạo đơn đăng ký ca",
            "acceptDetail": "Hãy tắt nó nếu công ty bạn không sử dụng đơn này",
            "hour": "Sử dụng đơn đăng ký ca theo giờ",
            "hourDetail": "Khi bật cài đặt này, hệ thống sẽ cho phép người dùng tạo đơn đăng ký ca theo giờ thay vì chọn nửa ca đầu, nửa ca sau",
            "maxDay": "Số ngày tối đa có thể làm đơn sau thời điểm đăng ký ca",
            "maxDayDetail": "VD: Nếu bạn cài đặt số ngày là 2, nhân sự muốn đăng ký ca từ ngày 04/07/2020 thì nhân sự đó chỉ có thể tạo đơn muộn nhất là ngày 06/07/2020",
            "minDay": "Số ngày tối thiểu có thể làm đơn trước thời điểm đăng ký ca",
            "minDayDetail": "VD: Nếu bạn cài đặt số ngày là 2, nhân sự muốn đăng ký ca từ ngày 04/07/2020 thì nhân sự đó phải tạo đơn trước 2 ngày là ngày 02/07/2020",
            "description": "Mô tả đơn đăng ký ca khi tạo đơn",
            "descriptionDetail": "Khi bật cài đặt này, nhân sự tạo đơn cần phải nhập nội dung mô tả thì hệ thống mới ghi nhận tạo mới thành công",
            "config": "Lý do đăng ký ca"
        }
    },
    "applicationWorkTimeConfig": {
        "pageHeader": {
            "workTime": "ĐƠN CHẾ ĐỘ",
            "sub": "Cho phép người dùng tạo đơn chế độ"
        },
        "input": {
            "hour": "Sử dụng đơn chế độ theo giờ",
            "maxDay": "Số ngày tối đa có thể làm đơn sau thời điểm chế độ",
            "minDay": "Số ngày tối thiểu có thể làm đơn trước thời điểm chế độ",
            "description": "Mô tả đơn chế độ khi tạo đơn",
            "config": "Lý do chế độ"
        },
        "label": {
            "accept": "Cho phép người dùng tạo đơn chế độ",
            "acceptDetail": "Hãy tắt nó nếu công ty bạn không sử dụng đơn này",
            "hour": "Sử dụng đơn chế độ theo giờ",
            "hourDetail": "Khi bật cài đặt này, hệ thống sẽ cho phép người dùng tạo đơn chế độ theo giờ thay vì chọn nửa ca đầu, nửa ca sau",
            "maxDay": "Số ngày tối đa có thể làm đơn sau thời điểm chế độ",
            "maxDayDetail": "VD: Nếu bạn cài đặt số ngày là 2, nhân sự muốn chế độ từ ngày 04/07/2020 thì nhân sự đó chỉ có thể tạo đơn muộn nhất là ngày 06/07/2020",
            "minDay": "Số ngày tối thiểu có thể làm đơn trước thời điểm chế độ",
            "minDayDetail": "VD: Nếu bạn cài đặt số ngày là 2, nhân sự muốn chế độ từ ngày 04/07/2020 thì nhân sự đó phải tạo đơn trước 2 ngày là ngày 02/07/2020",
            "description": "Mô tả đơn chế độ khi tạo đơn",
            "descriptionDetail": "Khi bật cài đặt này, nhân sự tạo đơn cần phải nhập nội dung mô tả thì hệ thống mới ghi nhận tạo mới thành công",
            "config": "Lý do chế độ"
        }
    },
    "applicationResignConfig": {
        "pageHeader": {
            "resign": "ĐƠN THÔI VIỆC",
            "sub": "Cho phép người dùng tạo đơn thôi việc"
        },
        "input": {
            "hour": "Sử dụng đơn thôi việc theo giờ",
            "maxDay": "Số ngày tối đa có thể làm đơn sau thời điểm thôi việc",
            "minDay": "Số ngày tối thiểu có thể làm đơn trước thời điểm thôi việc",
            "description": "Mô tả đơn thôi việc khi tạo đơn",
            "config": "Lý do thôi việc"
        },
        "label": {
            "accept": "Cho phép người dùng tạo đơn thôi việc",
            "acceptDetail": "Hãy tắt nó nếu công ty bạn không sử dụng đơn này",
            "hour": "Sử dụng đơn thôi việc theo giờ",
            "hourDetail": "Khi bật cài đặt này, hệ thống sẽ cho phép người dùng tạo đơn thôi việc theo giờ thay vì chọn nửa ca đầu, nửa ca sau",
            "maxDay": "Số ngày tối đa có thể làm đơn sau thời điểm thôi việc",
            "maxDayDetail": "VD: Nếu bạn cài đặt số ngày là 2, nhân sự muốn thôi việc từ ngày 04/07/2020 thì nhân sự đó chỉ có thể tạo đơn muộn nhất là ngày 06/07/2020",
            "minDay": "Số ngày tối thiểu có thể làm đơn trước thời điểm thôi việc",
            "minDayDetail": "VD: Nếu bạn cài đặt số ngày là 2, nhân sự muốn thôi việc từ ngày 04/07/2020 thì nhân sự đó phải tạo đơn trước 2 ngày là ngày 02/07/2020",
            "description": "Mô tả đơn thôi việc khi tạo đơn",
            "descriptionDetail": "Khi bật cài đặt này, nhân sự tạo đơn cần phải nhập nội dung mô tả thì hệ thống mới ghi nhận tạo mới thành công",
            "config": "Lý do thôi việc"
        }
    },
    "applicationOtherConfig": {
        "pageHeader": {
            "other": "ĐƠN CÀI ĐẶT KHÁC",
            "sub": "Cho phép người dùng tạo đơn cài đặt khác"
        },
        "input": {
            "isAcceptLate": "Sử dụng đơn cài đặt khác theo giờ",
            "creatorAllowed": "Số ngày tối đa có thể làm đơn sau thời điểm cài đặt khác",
            "minDay": "Số ngày tối thiểu có thể làm đơn trước thời điểm cài đặt khác",
            "description": "Mô tả đơn cài đặt khác khi tạo đơn",
            "config": "Lý do cài đặt khác"
        },
        "label": {
            "autoChange": "Thời gian để hệ thống sẽ tự động chuyển các đơn từ đang ở trạng thái chờ duyệt sang không duyệt sau khi chốt đơn từ",
            "autoChangeDetail": "Sau khi chốt đơn bên bảng chấm công, nếu còn tồn tại những đơn chờ duyệt, thì việc duyệt trở nên vô nghĩa.\nVới tính năng này, hệ thống sẽ tự động không duyệt những đơn treo, giúp giải phóng bộ nhớ hệ thống.",

            "isAcceptLate": "Không cho phép người dùng sửa đơn khi đã quá thời gian tạo đơn",
            "isAcceptLateDetail": "Khi bật cài đặt này, nhân sự không thể sửa lại đơn mà mình đã tạo nếu như thời điểm sửa nằm ngoài thời gian được phép tạo đơn.",

            "creatorAllowed": "Người được phép tạo hộ đơn từ",
            "creatorAllowedDetail": "Cho phép chọn những nhân sự được quyền tạo hộ đơn từ cho người khác.\nTùy chọn Tất cả nhân sự là tùy chọn để cho tất cả nhân viên có thể tạo hộ đơn cho nhau.\nKhi không chọn tùy chọn nào, hệ thống sẽ lấy theo quyền trong phân hệ đơn từ, các quyền quản lý đều được phép tạo hộ đơn từ./07/2020\nthì nhân sự đó chỉ có thể tạo đơn muộn nhất là ngày 06/07/2020",

            "minDay": "Số ngày tối thiểu có thể làm đơn trước thời điểm cài đặt khác",
            "minDayDetail": "VD: Nếu bạn cài đặt số ngày là 2, nhân sự muốn cài đặt khác từ ngày 04/07/2020 thì nhân sự đó phải tạo đơn trước 2 ngày là ngày 02/07/2020",
            "description": "Mô tả đơn cài đặt khác khi tạo đơn",
            "descriptionDetail": "Khi bật cài đặt này, nhân sự tạo đơn cần phải nhập nội dung mô tả thì hệ thống mới ghi nhận tạo mới thành công",
            "config": "Lý do cài đặt khác"
        },
        "option": {
            "oneDay": "Một ngày",
            "threeDays": "Ba ngày",
            "unlimited": "Không giới hạn",
            "all": "Quản lý tất cả",
            "company": "Quản lý công ty",
            "branch": "Quản lý chi nhánh",
            "department": "Quản lý phòng ban",
            "allHumanResource": "Tất cả nhân sự"
        }
    },
    "applicationMissionConfig": {
        "pageHeader": {
            "mission": "ĐƠN CÔNG TÁC",
            "sub": "Cho phép người dùng tạo đơn công tác"
        },
        "input": {
            "hour": "Sử dụng đơn công tác theo giờ",
            "maxDay": "Số ngày tối đa có thể làm đơn sau thời điểm công tác",
            "minDay": "Số ngày tối thiểu có thể làm đơn trước thời điểm công tác",
            "description": "Mô tả đơn công tác khi tạo đơn",
            "config": "Lý do công tác"
        },
        "label": {
            "accept": "Cho phép người dùng tạo đơn công tác",
            "acceptDetail": "Hãy tắt nó nếu công ty bạn không sử dụng đơn này",
            "hour": "Sử dụng đơn công tác theo giờ",
            "hourDetail": "Khi bật cài đặt này, hệ thống sẽ cho phép người dùng tạo đơn công tác theo giờ thay vì chọn nửa ca đầu, nửa ca sau",
            "maxDay": "Số ngày tối đa có thể làm đơn sau thời điểm công tác",
            "maxDayDetail": "VD: Nếu bạn cài đặt số ngày là 2, nhân sự muốn công tác từ ngày 04/07/2020 thì nhân sự đó chỉ có thể tạo đơn muộn nhất là ngày 06/07/2020",
            "minDay": "Số ngày tối thiểu có thể làm đơn trước thời điểm công tác",
            "minDayDetail": "VD: Nếu bạn cài đặt số ngày là 2, nhân sự muốn công tác từ ngày 04/07/2020 thì nhân sự đó phải tạo đơn trước 2 ngày là ngày 02/07/2020",
            "description": "Mô tả đơn công tác khi tạo đơn",
            "descriptionDetail": "Khi bật cài đặt này, nhân sự tạo đơn cần phải nhập nội dung mô tả thì hệ thống mới ghi nhận tạo mới thành công",
            "config": "Lý do công tác",
            "feeAmount": "Công tác phí",
            "mission-vehicle": "Phương tiện công tác"
        }
    },
    "applicationOvertimeConfig": {
        "pageHeader": {
            "overtime": "ĐƠN LÀM THÊM",
            "sub": "Cho phép người dùng tạo đơn làm thêm"
        },
        "input": {
            "hour": "Sử dụng đơn làm thêm theo giờ",
            "maxDay": "Số ngày tối đa có thể làm đơn sau thời điểm làm thêm",
            "minDay": "Số ngày tối thiểu có thể làm đơn trước thời điểm làm thêm",
            "description": "Mô tả đơn làm thêm khi tạo đơn",
            "config": "Lý do làm thêm"
        },
        "label": {
            "accept": "Cho phép người dùng tạo đơn làm thêm",
            "acceptDetail": "Hãy tắt nó nếu công ty bạn không sử dụng đơn này",
            "hour": "Sử dụng đơn làm thêm theo giờ",
            "hourDetail": "Khi bật cài đặt này, hệ thống sẽ cho phép người dùng tạo đơn làm thêm theo giờ thay vì chọn nửa ca đầu, nửa ca sau",
            "maxDay": "Số ngày tối đa có thể làm đơn sau thời điểm làm thêm",
            "maxDayDetail": "VD: Nếu bạn cài đặt số ngày là 2, nhân sự muốn làm thêm từ ngày 04/07/2020 thì nhân sự đó chỉ có thể tạo đơn muộn nhất là ngày 06/07/2020",
            "minDay": "Số ngày tối thiểu có thể làm đơn trước thời điểm làm thêm",
            "minDayDetail": "VD: Nếu bạn cài đặt số ngày là 2, nhân sự muốn làm thêm từ ngày 04/07/2020 thì nhân sự đó phải tạo đơn trước 2 ngày là ngày 02/07/2020",
            "description": "Mô tả đơn làm thêm khi tạo đơn",
            "descriptionDetail": "Khi bật cài đặt này, nhân sự tạo đơn cần phải nhập nội dung mô tả thì hệ thống mới ghi nhận tạo mới thành công",
            "config": "Lý do làm thêm"
        }
    },
    "applicationLateConfig": {
        "pageHeader": {
            "late": "ĐƠN ĐI MUỘN VỀ SỚM"
        },
        "label": {
            "accept": "Cho phép người dùng tạo đơn đi muộn về sớm",
            "acceptDetail": "Hãy tắt nó nếu công ty bạn không sử dụng đơn này",
            "compensationDifferentDay": "Cho phép làm bù trong nhiều khoảng thời gian",
            "compensationDifferentDayDetail": "Khi bật cài đặt này, nhân sự tạo đơn sẽ được phép chọn làm bù trong nhiều khoảng thời gian khác nhau",
            "maxHour": "Thời gian cho phép nghỉ tối đa trong ngày",
            "maxHourDetail": "VD: Nếu bạn cài đặt thời gian nghỉ tối đa là 1 giờ, tổng thời gian xin đi muộn, về sớm, vắng mặt giữa giờ không được vượt quá 1 giờ",
            "maxCount": "Số lượng đơn làm bù được phép tạo trong tuần",
            "maxCountDetail": "VD: Nếu bạn cài đặt số lượng là 2, nhân sự chỉ có thể tạo tối đa 2 đơn trong tuần"
        }
    }
}
